<template>
    <app-card class="mb-4">
        <div class="row">
            <div class="col-md-7 mb-3">
                <input class="form-control custom-green-input-bg" :placeholder="`${$t('Search')}...`" type="text" v-model="term"/>
            </div>
            <div class="col-md-5">
                <app-button v-if="term" native-type="button" type="warning" @click="cancelFilter" class="mt-1" small>
                    {{ $t('Cancel') }}
                </app-button>
                <app-loader-gif class="mt-2" v-if="loading"/>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th @click="orderBy('name')" class="pointer">
                            {{ $t('Name') }}
                            <span v-html="order_field === 'name' ? active_sort_icon : sort_icon"/>
                        </th>
                        <th @click="orderBy('email')" class="pointer">
                            {{ $t('Email') }}
                            <span v-html="order_field === 'email' ? active_sort_icon : sort_icon"/>
                        </th>
                        <th @click="orderBy('phone')" class="pointer">
                            {{ $t('Phone') }}
                            <span v-html="order_field === 'phone' ? active_sort_icon : sort_icon"/>
                        </th>
                        <th @click="orderBy('address')" class="pointer">
                            {{ $t('Address') }}
                            <span v-html="order_field === 'address' ? active_sort_icon : sort_icon"/>
                        </th>
                        <th @click="orderBy('company_name')" class="pointer">
                            {{ $t('Company name') }}
                            <span v-html="order_field === 'company_name' ? active_sort_icon : sort_icon"/>
                        </th>
                        <th @click="orderBy('discount_percent')" class="pointer">
                            {{ $t('Discount') }} %
                            <span v-html="order_field === 'discount_percent' ? active_sort_icon : sort_icon"/>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(client, i) in orderedClients" :key="i">
                        <td>{{ i + 1}}</td>
                        <td>{{ client.name }}</td>
                        <td>{{ client.email }}</td>
                        <td>{{ client.phone }}</td>
                        <td>{{ client.address | truncate(30) }}</td>
                        <td>{{ client.company_name }}</td>
                        <td>{{ client.discount_percent }}</td>
                        <td class="p-0">
                            <div class="text-right" style="white-space: nowrap;">
                                <router-link :to="{name: 'clients.show', params: {client_id: client.id}}" class="btn btn-info btn-sm text-white">
                                    {{ $t('View') }}
                                </router-link>
                                <router-link v-if="$store.getters.canEditClients" :to="{name: 'clients.edit', params: {client_id: client.id}}" class="btn btn-primary btn-sm text-white ml-2">
                                    {{ $t('Edit') }}
                                </router-link>
                                <app-button v-if="$store.getters.canDeleteClients" native-type="button" type="danger" @click="destroy(client.id)" small>
                                    {{ $t('Delete') }}
                                </app-button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </app-card>
</template>

<script>
import ClientService from '@services/client.service';
import {mapGetters} from 'vuex';
import orderBy from 'lodash/orderBy';

export default {
    data() {
        return {
            loading: true,
            term: '',
            order_field: 'created_at',
            order_dir: 'desc',
            sort_icon: '<span class="mdi mdi-18px mdi-menu-swap"/>',
            clients: []
        };
    },
    computed: {
        ...mapGetters(['locale']),
        filteredClients() {
            if (this.clients.length && (this.term.length > 3 || this.term.length === 0)) {
                return this.clients.filter(client => {
                    const term = this.term.toString().toLowerCase();
                    return (
                        client.name.toLowerCase().match(term) ||
                        client.email.toLowerCase().match(term) ||
                        client.phone.match(term) ||
                        (client.address !== null ? client.address.match(term) : false) ||
                        (client.company_name !== null ? client.company_name.toLowerCase().match(term) : false)
                    );
                });
            }
            return false;
        },
        orderedClients() {
            return orderBy(this.filteredClients, this.order_field, this.order_dir);
        },
        active_sort_icon() {
            if (this.order_dir === 'desc') {
                return '<span class="mdi mdi-18px mdi-menu-down"/>';
            } else {
                return '<span class="mdi mdi-18px mdi-menu-up"/>';
            }
        }
    },
    methods: {
        orderBy(field) {
            this.order_field = field;
            if (this.order_dir === 'desc') {
                this.order_dir = 'asc';
            } else {
                this.order_dir = 'desc';
            }
        },
        cancelFilter() {
            this.term = '';
        },
        getClients() {
            this.loading = true;
            ClientService.clients().then(res => {
                this.loading = false;
                this.clients = res;
            });
        },
        destroy(clientId) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            ClientService.destroy(clientId).then(res => {
                const index = this.clients.findIndex(client => client.id === clientId);
                this.clients.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    created() {
        this.getClients();
    }
};
</script>
